import ReviewsIcon from "@mui/icons-material/Reviews";
import { Box, Dialog, Stack, Typography, useTheme } from "@mui/material";
import { styled } from "@mui/material/styles";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { useSelector } from "react-redux";
import { useSnackbar } from "../../../lib/context/snackbarContext";
import DialogHeader from "../../../components/dialog/DialogHeader";
import DialogBody from "../../../components/dialog/DialogBody";
import DialogActionButtons from "../../../components/dialog/DialogActions";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import Counter from "../../../components/counterButton";
import { CURRENCY } from "../../../lib/variables";
import { t } from "i18next";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing("24px"),
  },
  "& .MuiPaper-root": {
    width: "400px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
  "& .MuiTableContainer-root .MuiTable-root .MuiTableHead-root": {
    backgroundColor: "#f3f3f3",
  },
  "& .MuiTableCell-root ": {
    padding: "8px 16px",
  },
}));

const VariantProductDialog = forwardRef(
  ({ selectedProducts, setSelectedProducts }, ref) => {
    const { palette } = useTheme();

    const { showSnackbar } = useSnackbar();
    const [open, setOpen] = useState(false);
    const [dialogData, setDialogData] = useState(null);
    const [productDetail, setProductDetail] = useState(null);

    const [selectedColor, setSelectedColor] = useState(null);
    const [selectedSize, setSelectedSize] = useState(null);
    const [selectedSizeColor, setSelectedSizeColor] = useState(null);
    const [selectedWeight, setSelectedWeight] = useState(null);
    const [isInStock, setIsInStock] = useState(false);
    const [selectedQty, setSelectedQty] = useState(1);

    const [disableCounters, setDisAbleCounters] = useState({
      add: false,
      subtract: true,
    });

    useEffect(() => {
      if (dialogData) {
        let { color, size, sizeWithColor, quantity, weigth } =
          dialogData?.product;

        if (color.length > 0) {
          for (let index = 0; index < color?.length; index++) {
            if (color[index].quantity > 0) {
              setSelectedColor(color[index]);
              setIsInStock(true);
              break;
            }
          }
        }

        if (size?.length > 0) {
          for (let index = 0; index < size?.length; index++) {
            if (size[index].quantity > 0) {
              setSelectedSize(size[index]);
              setIsInStock(true);
              break;
            }
          }
        }

        if (weigth?.length > 0) {
          for (let index = 0; index < weigth?.length; index++) {
            if (weigth[index].quantity > 0) {
              setSelectedWeight(weigth[index]);
              setIsInStock(true);
              break;
            }
          }
        }

        if (sizeWithColor?.length > 0) {
          outerLoop: for (
            let index = 0;
            index < sizeWithColor?.length;
            index++
          ) {
            for (
              let jindex = 0;
              jindex < sizeWithColor[index].colors?.length;
              jindex++
            ) {
              if (sizeWithColor[index].colors[jindex].quantity > 0) {
                setSelectedSizeColor(sizeWithColor[index]);
                setSelectedColor(sizeWithColor[index].colors[jindex]);
                setIsInStock(true);

                break outerLoop;
              }
            }
          }
        }

        if (quantity > 0) {
          setIsInStock(true);
        }
      }
    }, [dialogData]);

    useImperativeHandle(ref, () => ({
      openDialog(params) {
        setDialogData(params);
        setProductDetail(params?.product);
        setOpen(true);
      },
      closeDialog() {
        handleClose();
      },
    }));

    const handleClose = () => {
      setOpen(false);
      setSelectedQty(1);
      setProductDetail(null);
      setSelectedColor(null);
      setSelectedSize(null);
      setSelectedSizeColor(null);
      setSelectedWeight(null);
      setDisAbleCounters({
        add: false,
        subtract: true,
      });
      setIsInStock(false);
      setDialogData(null);
    };

    let pprice =
      productDetail?.discount > 0
        ? productDetail?.discount
        : productDetail?.price;

    let pdiscount = productDetail?.discount > 0 ? productDetail?.price : null;

    const renderSize = (productDetail) => {
      console.log(selectedSize, "SELECTED_SIZE");
      return (
        <Stack direction="row" alignItems={"center"} gap={"15px"}>
          {productDetail?.size?.map((val, index) => {
            const selected =
              selectedSize !== null && selectedSize?.name === val?.name;
            return (
              <Box
                key={index}
                position={"relative"}
                border={`2px solid ${
                  selected ? palette.primary.main : "#8d8d8d"
                }`}
                height={35}
                width={35}
                borderRadius={1}
                bgcolor={selected ? "primary.main" : "text.white"}
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
                sx={{
                  cursor: val.quantity === 0 ? "not-allowed" : "pointer",
                }}
                onClick={() => {
                  if (val.quantity !== 0) {
                    setSelectedSize(val);
                    setSelectedQty(1);
                    // setDisAbleCounters((pre) => ({ ...pre, add: false }));
                  }
                }}
              >
                <Box position={"absolute"} top={0}>
                  {val.quantity === 0 && (
                    <CloseRoundedIcon
                      htmlColor={val.color === "#ff1111" ? "#ff1111" : "red"}
                      sx={{ fontSize: "2rem" }}
                    />
                  )}
                </Box>
                <Typography
                  variant={"body1"}
                  color={selected ? "text.white" : "text.black"}
                  sx={{
                    opacity: val.quantity === 0 ? 0.5 : 1,
                  }}
                >
                  {val?.name}
                </Typography>
              </Box>
            );
          })}
        </Stack>
      );
    };

    const renderColors = (color) => {
      return (
        <Stack direction="row" alignItems={"center"} gap={"5px"}>
          {color?.map((val, index) => {
            const selected =
              selectedColor !== null && selectedColor.color === val.color;

            return (
              <Box
                key={index}
                border={`2px solid ${
                  selected ? palette.text.black : val.color
                }`}
                borderRadius={"100%"}
                sx={{
                  cursor: val.quantity === 0 ? "not-allowed" : "pointer",
                }}
                onClick={() => {
                  if (val.quantity !== 0) {
                    setSelectedColor(val);
                    setSelectedQty(1);
                    setDisAbleCounters((pre) => ({ ...pre, add: false }));
                  }
                }}
              >
                <Box
                  key={index}
                  border={`2px solid ${selected ? palette.text.white : val}`}
                  height={20}
                  width={20}
                  borderRadius={"100%"}
                  bgcolor={val?.color}
                  display={"flex"}
                  justifyContent={"center"}
                  alignItems={"center"}
                >
                  {val.quantity === 0 && (
                    <CloseRoundedIcon
                      htmlColor={val.color === "#ff1111" ? "#ff1111" : "red"}
                      sx={{ fontSize: "1.3rem" }}
                    />
                  )}
                </Box>
              </Box>
            );
          })}
        </Stack>
      );
    };

    const renderSizesWithColor = () => {
      return (
        <Stack direction="row" alignItems={"center"} gap={"15px"}>
          {productDetail?.sizeWithColor?.map((val, index) => {
            const selected =
              selectedSizeColor !== null && selectedSizeColor.name === val.name;

            // Check if all colors have zero quantity
            const allColorsUnavailable = val.colors.every(
              (color) => color.quantity === 0
            );

            return (
              <Box
                key={index}
                position={"relative"}
                border={`2px solid ${
                  selected ? palette.primary.main : "#8d8d8d"
                }`}
                height={35}
                width={35}
                borderRadius={1}
                bgcolor={selected ? "primary.main" : "text.white"}
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
                sx={{
                  cursor: allColorsUnavailable ? "not-allowed" : "pointer",
                }}
                onClick={() => {
                  if (!allColorsUnavailable) {
                    setSelectedSizeColor(val);
                    setDisAbleCounters((pre) => ({ ...pre, add: false }));
                    setSelectedQty(1);
                    setSelectedColor(null);
                  }
                }}
              >
                {allColorsUnavailable && (
                  <Box position={"absolute"} top={0}>
                    <CloseRoundedIcon
                      htmlColor={"red"}
                      sx={{ fontSize: "2rem" }}
                    />
                  </Box>
                )}
                <Typography
                  variant={"body1"}
                  color={selected ? "text.white" : "text.black"}
                  sx={{
                    opacity: allColorsUnavailable ? 0.5 : 1,
                  }}
                >
                  {val?.name}
                </Typography>
              </Box>
            );
          })}
        </Stack>
      );
    };

    const renderWeights = (productDetail) => {
      return (
        <Stack direction="row" alignItems={"center"} gap={"15px"}>
          {productDetail?.weigth?.map((val, index) => {
            const selected =
              selectedWeight !== null && selectedWeight?.name === val?.name;
            return (
              <Box
                key={index}
                px={1}
                position={"relative"}
                border={`2px solid ${
                  selected ? palette.primary.main : "#8d8d8d"
                }`}
                height={35}
                width={"auto"}
                borderRadius={1}
                bgcolor={selected ? "primary.main" : "text.white"}
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
                sx={{
                  cursor: val.quantity === 0 ? "not-allowed" : "pointer",
                }}
                onClick={() => {
                  if (val.quantity !== 0) {
                    setSelectedWeight(val);
                    setSelectedQty(1);
                    setDisAbleCounters((pre) => ({ ...pre, add: false }));
                  }
                }}
              >
                <Box position={"absolute"} top={0}>
                  {val.quantity === 0 && (
                    <CloseRoundedIcon
                      htmlColor={val.color === "#ff1111" ? "#ff1111" : "red"}
                      sx={{ fontSize: "2rem" }}
                    />
                  )}
                </Box>
                <Typography
                  variant={"body1"}
                  color={selected ? "text.white" : "text.black"}
                  sx={{
                    opacity: val.quantity === 0 ? 0.5 : 1,
                  }}
                >
                  {val?.name}
                </Typography>
              </Box>
            );
          })}
        </Stack>
      );
    };

    const handleDecreaseQty = () => {
      if (selectedQty == 1) {
        return setDisAbleCounters((pre) => ({ ...pre, subtract: true }));
      }
      setSelectedQty((pre) => pre - 1);
      setDisAbleCounters((pre) => ({ ...pre, add: false }));
    };

    const handleIncreaseQty = (product) => {
      if (product.quantity > 0) {
        if (selectedQty == product.quantity) {
          setDisAbleCounters({ ...disableCounters, add: true });
        } else {
          setDisAbleCounters((pre) => ({ ...pre, subtract: false }));
          setSelectedQty((pre) => pre + 1);
        }
      }

      if (product?.size?.length > 0 && selectedSize !== null) {
        if (selectedQty === selectedSize.quantity) {
          setDisAbleCounters({ ...disableCounters, add: true });
        } else {
          setDisAbleCounters((pre) => ({ ...pre, subtract: false }));
          setSelectedQty((pre) => pre + 1);
        }
      }

      if (product?.weigth?.length > 0 && selectedWeight !== null) {
        if (selectedQty === selectedWeight.quantity) {
          setDisAbleCounters({ ...disableCounters, add: true });
        } else {
          setDisAbleCounters((pre) => ({ ...pre, subtract: false }));
          setSelectedQty((pre) => pre + 1);
        }
      }

      if (product?.color?.length > 0 && selectedColor !== null) {
        if (selectedQty === selectedColor.quantity) {
          setDisAbleCounters({ ...disableCounters, add: true });
        } else {
          setDisAbleCounters((pre) => ({ ...pre, subtract: false }));
          setSelectedQty((pre) => pre + 1);
        }
      }

      if (product?.sizeWithColor?.length > 0 && selectedSizeColor !== null) {
        if (!selectedColor) {
          return showSnackbar(t("selectColorToIncreaseQuantity"), "error");
        }

        if (selectedQty === selectedColor.quantity) {
          setDisAbleCounters({ ...disableCounters, add: true });
        } else {
          setDisAbleCounters((pre) => ({ ...pre, subtract: false }));
          setSelectedQty((pre) => pre + 1);
        }
      }
    };

    const handleAddProduct = (product) => {
      let tempCart = [...selectedProducts];

      if (product.quantity > 0) {
        const existingProductIndex = tempCart.findIndex(
          (item) => item._id === productDetail._id
        );

        if (existingProductIndex !== -1) {
          const updatedProduct = {
            ...tempCart[existingProductIndex],
            selectedQty,
          };
          tempCart[existingProductIndex] = updatedProduct;
        } else {
          tempCart.push({ ...productDetail, selectedQty });
        }
      }

      if (product?.size?.length > 0) {
        let existingProductIndex = tempCart.findIndex(
          (itemmm) =>
            itemmm._id == productDetail._id &&
            itemmm.selectedSize.name == selectedSize.name
        );
        if (existingProductIndex !== -1) {
          const updatedProduct = {
            ...tempCart[existingProductIndex],
            selectedQty,
          };
          tempCart[existingProductIndex] = updatedProduct;
        } else {
          tempCart.push({
            ...productDetail,
            selectedQty,
            selectedSize,
          });
        }
      }

      if (product?.weigth?.length > 0) {
        let existingProductIndex = tempCart.findIndex(
          (itemmm) =>
            itemmm._id == productDetail._id &&
            itemmm.selectedWeight.name == selectedWeight.name
        );
        if (existingProductIndex !== -1) {
          const updatedProduct = {
            ...tempCart[existingProductIndex],
            selectedQty,
          };
          tempCart[existingProductIndex] = updatedProduct;
        } else {
          tempCart.push({
            ...productDetail,
            selectedQty,
            selectedWeight,
            price: selectedWeight.price,
            finalPrice: selectedWeight.price,
          });
        }
      }

      if (product?.color?.length > 0) {
        let existingProductIndex = tempCart.findIndex(
          (itemmm) =>
            itemmm._id == product._id &&
            itemmm.selectedColor.color == selectedColor.color
        );
        if (existingProductIndex !== -1) {
          const updatedProduct = {
            ...tempCart[existingProductIndex],
            selectedQty,
          };
          tempCart[existingProductIndex] = updatedProduct;
        } else {
          tempCart.push({
            ...product,
            selectedQty,
            selectedColor,
          });
        }
      }

      if (product?.sizeWithColor?.length > 0) {
        if (!selectedColor) {
          return showSnackbar(t("selectAvailableColor"), "error");
        }
        let existingProductIndex = tempCart.findIndex(
          (itemmm) =>
            itemmm._id == product._id &&
            itemmm.selectedSizeWithColor.size == selectedSizeColor.name &&
            itemmm.selectedSizeWithColor.color == selectedColor.color
        );
        if (existingProductIndex !== -1) {
          const updatedProduct = {
            ...tempCart[existingProductIndex],
            selectedQty,
          };
          tempCart[existingProductIndex] = updatedProduct;
        } else {
          let newObjjj = {
            ...product,
            selectedQty,
            selectedSizeWithColor: {
              size: selectedSizeColor?.name,
              color: selectedColor?.color,
              colorName: selectedColor.colorName,
              quantity: selectedColor?.quantity,
            },
          };
          tempCart.push(newObjjj);
        }
      }

      showSnackbar(t("productAddedToCart"), "success");
      setSelectedProducts(tempCart);
      handleClose();
    };

    return (
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogHeader
          title={"productVariation"}
          secondaryHeading={t("addProduct")}
          icon={
            <ReviewsIcon sx={{ fontSize: "2rem", color: "primary.main" }} />
          }
          onClose={handleClose}
        />

        <DialogBody>
          {productDetail?.size?.length > 0 ? (
            <Stack gap={"15px"} alignItems={"center"} mb={2}>
              <Typography
                variant="body1"
                fontWeight={500}
                textTransform={"capitalize"}
              >
                {t("selectSize")}
              </Typography>
              {renderSize(productDetail)}
            </Stack>
          ) : null}

          {/* product include weights */}
          {productDetail?.weigth?.length > 0 ? (
            <Stack gap={"15px"} alignItems={"center"} mb={2}>
              <Typography
                variant="body1"
                fontWeight={500}
                textTransform={"capitalize"}
              >
                {t("selectWeight")}
              </Typography>
              {renderWeights(productDetail)}
            </Stack>
          ) : null}

          {/* product include sizes with colors */}
          {productDetail?.sizeWithColor?.length > 0 ? (
            <Stack gap={"15px"} alignItems={"center"} mb={2}>
              <Typography variant="body1" fontWeight={500}>
                {t("selectSize")}
              </Typography>
              {renderSizesWithColor(productDetail)}
            </Stack>
          ) : null}
          {selectedSizeColor !== null ? (
            <Stack gap={"15px"} alignItems={"center"} mb={2}>
              <Typography variant="body1" fontWeight={500}>
                {t("selectColor")}
              </Typography>
              {renderColors(selectedSizeColor?.colors)}
            </Stack>
          ) : null}

          {/* product include colors */}
          {productDetail?.color?.length > 0 ? (
            <Stack gap={"15px"} alignItems={"center"} mb={2}>
              <Typography variant="body1" fontWeight={500}>
                {t("colors")}:
              </Typography>
              {renderColors(productDetail.color)}
            </Stack>
          ) : null}

          <Box pb={1}>
            <Counter
              value={selectedQty}
              handleDecreaseQty={handleDecreaseQty}
              handleIncreaseQty={() => handleIncreaseQty(productDetail)}
              disbleCounters={disableCounters}
            />
          </Box>

          {productDetail?.type !== "Food" &&
            productDetail?.weigth?.length === 0 && (
              <Stack
                direction={"row"}
                alignItems={"center"}
                justifyContent={"center"}
                gap={1}
              >
                <Typography variant="h6" fontWeight={500}>
                  {`${CURRENCY} ${pprice}`}
                </Typography>
                {pdiscount > 0 && (
                  <Typography
                    variant="body1"
                    color={"text.gunmetal"}
                    sx={{ textDecoration: "line-through" }}
                  >
                    {`${CURRENCY} ${pdiscount}`}
                  </Typography>
                )}
              </Stack>
            )}

          {productDetail?.type == "Food" &&
            productDetail?.weigth?.length > 0 && (
              <Stack direction={"row"} alignItems={"center"} gap={1}>
                <Typography variant="h6" fontWeight={500}>
                  {`${CURRENCY} ${selectedWeight?.price || 0}`}
                </Typography>
              </Stack>
            )}
        </DialogBody>
        <DialogActionButtons
          onCancel={handleClose}
          confirmText="add"
          onConfirm={() => {
            handleAddProduct(dialogData?.product);
            // if (dialogData?.type === "product") {
            //   handleAddReviewInProduct();
            // } else {
            //   handleAddReviewInService();
            // }
          }}
        />
      </BootstrapDialog>
    );
  }
);

export default VariantProductDialog;
